const loadHeroImages = () => {
  let videoDefer = document.querySelector('video[video-src]');
  if(videoDefer) {
    let url = videoDefer.getAttribute('video-src');
    videoDefer.querySelector('source').setAttribute('src', url);
    
    videoDefer.load(); // Ensures the video is loaded with the new source
    
    videoDefer.addEventListener('loadeddata', () => {
      videoDefer.play();
    }, { once: true }); // Ensures the event listener is only called once
  }
};

const loadScripts = () => {
  console.log('Loaded');
  loadHeroImages();
};

window.addEventListener('load', loadScripts);

$(document).ready(function () {

  $('#slick-static-feat').slick({
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: false,
    pauseOnHover: true,
    cssEase: 'linear',	
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
        {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
  
  // Product Slider
  $('#slick-products').slick({
    dots: false,
    arrows: true,
    infinite: false,
    autoplay: false,
    speed: 800,
    cssEase: 'linear',	
    prevArrow: '<button class="slide-arrow prev-arrow"><i class="far fa-long-arrow-left"></i></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><i class="far fa-long-arrow-right"></i></button>',
    slidesToShow: 4,
    swipeToSlide: true,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
            }
        },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }]
  });
  
  $('#slick-review').slick({
    dots: false,
    arrows: true,
    infinite: false,
    autoplay: false,
    speed: 700,
    prevArrow: '<button class="slide-arrow prev-arrow"><i class="far fa-long-arrow-left"></i></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><i class="far fa-long-arrow-right"></i></button>',
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    adaptiveHeight: false,
  });

	  
  // Feature SLider

  $("#feat-content-slick").slick({
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    asNavFor: "#feat-title-slick",
    dots: false,
    adaptiveHeight: false
  });
  $("#feat-title-slick").slick({
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: "#feat-content-slick",
    dots: false,
    focusOnSelect: true,
    prevArrow: '<button class="slide-arrow prev-arrow"><i class="fas fa-chevron-left"></i></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><i class="fas fa-chevron-right"></i></button>',
    responsive: [
      {
          breakpoint: 992,
          settings: {
              slidesToShow: 3,
          }
      },
      {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      }
    }]
  });


  $('#slick-needed').slick({
    dots: false,
    arrows: true,
    infinite: false,
    autoplay: false,
    speed: 800,
    cssEase: 'linear',	
    prevArrow: '<button class="slide-arrow prev-arrow"><i class="far fa-long-arrow-left"></i></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><i class="far fa-long-arrow-right"></i></button>',
    slidesToShow: 3,
    swipeToSlide: true,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
            }
        },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }]
  });




  /*_____ Video _____*/
  $(document).on("click", ".vid_blk .play-vid", function () {
    let sec = $(this).parents("section")
    sec.find(".video_popup").fadeIn()
    let src = sec.find(".video_popup iframe").attr("data-src")
    sec.find(".video_popup iframe").attr("src", src)
  })
  $(document).on("click", ".video_popup .crossBtn", function () {
    $(".video_popup iframe").attr("src", "")
    $(".video_popup").fadeOut()
  });

  // To check If it is in Viewport
  const counters = document.querySelectorAll(".counter");
  
  counters.forEach((counter) => {
    counter.innerText = "0";
    const updateCounter = () => {
      const target = +counter.getAttribute("data-target");
      const count = +counter.innerText;
      const increment = target / 200;
      if (count < target) {
        counter.innerText = `${Math.ceil(count + increment)}`;
        setTimeout(updateCounter, 1);
      } else counter.innerText = target;
    };
    updateCounter();
  });

  $('#slick-pro-static-feat').slick({
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 6000,
    pauseOnHover: true,
    cssEase: 'linear',	
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
        }
      }
    ]
  });


  $('#slick-product-feat-feature').slick({
    dots: false,
    arrows: true,
    infinite: false,
    autoplay: false,
    speed: 800,
    cssEase: 'linear',	
    prevArrow: '<button class="slide-arrow prev-arrow"><i class="far fa-long-arrow-left"></i></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><i class="far fa-long-arrow-right"></i></button>',
    slidesToShow: 3,
    swipeToSlide: true,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
            }
        },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }]
  });


  $('#slick-what-in-box').slick({
    dots: false,
    arrows: false,
    infinite: false,
    autoplay: false,
    speed: 800,
    cssEase: 'linear',	
    prevArrow: '<button class="slide-arrow prev-arrow"><i class="far fa-long-arrow-left"></i></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><i class="far fa-long-arrow-right"></i></button>',
    slidesToShow: 5,
    swipeToSlide: true,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 4,
                arrows: true,
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow:3,
                arrows: true,
            }
        },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3,
          arrows: true,
        }
      },
    {
        breakpoint: 575,
        settings: {
          slidesToShow: 2,
          arrows: true,
        }
      }]
  });
  
  /*_____ FAQ's _____*/
  $(".faq_blk:nth-child(1)").addClass("active")
  $(document).on("click", ".faq_blk > .title", function () {
    $(".faq_blk").not($(this).parent().toggleClass("active")).removeClass("active")
    $(".faq_blk > .text").not($(this).parent().children(".text").slideToggle()).slideUp()
  });

  /*_____ FAQ's _____*/
  $(document).on("click", ".faq__blk > h5", function () {
    $(".faq__blk").not($(this).parent().toggleClass("active")).removeClass("active")
    $(".faq__blk>.text").not($(this).parent().find(".text").slideToggle()).slideUp()
  });

  if(document.querySelector('.product-info')){
    $(document).scroll(function(){
      if($(this).scrollTop() >= $('.product-info').offset().top + 600) {
        $(".product-quick-add").addClass("is-visible");
      } else {
        $(".product-quick-add").removeClass("is-visible");;
      }
    });
  }

  var hiddenInput = document.querySelector('input[name="option1"]');
  // console.log(JSON.stringify(hiddenInput.value.trim()));

  if(hiddenInput != null){
    

  if(hiddenInput.value.trim() === 'With Reverse Camera') {
    document.querySelector('.position-13').style.display = 'none';
    document.querySelector('.position-1').style.display = 'none';
  } else {
    document.querySelector('.position-12').style.display = 'none';
    document.querySelector('.position-2').style.display = 'none';
  }
  hiddenInput.addEventListener('change', function () {
    console.log(JSON.stringify(this.value.trim()));
    if(this.value.trim() === 'With Reverse Camera') {
      document.querySelector('.position-12').style.display = 'block';
      document.querySelector('.position-13').style.display = 'none';
      document.querySelector('.position-1').style.display = 'none';
    } else {
      document.querySelector('.position-13').style.display = 'block';
      document.querySelector('.position-12').style.display = 'none';
      document.querySelector('.position-2').style.display = 'none';
    }
  });

      }
  
});

